import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Experience from "@/components/site/Experience";
import Projects from "@/components/site/Projects";
import Education from "@/components/site/Education";
import Expertise from "@/components/site/Expertise";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Portfolio() {
  return (
    <main data-testid="portfolio-root" className="min-h-screen">
      <Navbar />
      <Hero />
      <About />
      <Experience />
      <Projects />
      <Education />
      <Expertise />
      <Contact />
      <Footer />
    </main>
  );
}
